<template>
  <el-card>
    <div slot="header">
      Leltározási utasítás
    </div>
    <el-form
      ref="instructionForm"
      label-position="top"
      :model="stockTakingInstruction"
      :rules="rules"
    >
      <el-form-item
        prop="is_ticket_required"
      >
        <el-checkbox
          v-model="stockTakingInstruction.is_ticket_required"
          :disabled="dialogType === 'view'"
        >
          Jegy kiadás
        </el-checkbox>
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="Készletek köre"
            prop="stock_tool"
          >
            <el-select
              v-model="stockTakingInstruction.stock_tool"
              style="width: 100%;"
              filterable
              :disabled="dialogType === 'view'"
              value-key="id"
            >
              <el-option
                v-for="tool in stockTakingTools"
                :key="tool.id"
                :label="tool.name"
                :value="tool"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Egyéb eszközök köre"
            prop="other_tool"
          >
            <el-select
              v-model="stockTakingInstruction.other_tool"
              style="width: 100%;"
              filterable
              :disabled="dialogType === 'view'"
              value-key="id"
            >
              <el-option
                v-for="tool in stockTakingTools"
                :key="tool.id"
                :label="tool.name"
                :value="tool"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="Tárgyi eszközök köre"
            prop="tangible_assets_tool"
          >
            <el-select
              v-model="stockTakingInstruction.tangible_assets_tool"
              style="width: 100%;"
              filterable
              :disabled="dialogType === 'view'"
              value-key="id"
            >
              <el-option
                v-for="tool in stockTakingTools"
                :key="tool.id"
                :label="tool.name"
                :value="tool"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Idegen tulajdon"
            prop="strange_belongings_tool"
          >
            <el-select
              v-model="stockTakingInstruction.strange_belongings_tool"
              style="width: 100%;"
              filterable
              :disabled="dialogType === 'view'"
              value-key="id"
            >
              <el-option
                v-for="tool in stockTakingTools"
                :key="tool.id"
                :label="tool.name"
                :value="tool"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</template>
<script>
  export default {
    props: ['stockTakingReport', 'dialogType'],
    data() {
      return {
        stockTakingInstruction: {
          stock_tool: null,
          other_tool: null,
          tangible_assets_tool: null,
          strange_belongings_tool: null,
          is_ticket_required: false,
        },
        stockTakingTools: [],
        rules: {
          stock_tool: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
          other_tool: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
          tangible_assets_tool: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
          strange_belongings_tool: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
        },
      }
    },
    watch: {
      stockTakingReport(newVal) {
        this.stockTakingInstruction.stock_tool = Object.assign({}, newVal.stock_tool);
        this.stockTakingInstruction.other_tool = Object.assign({}, newVal.other_tool);
        this.stockTakingInstruction.tangible_assets_tool = Object.assign({}, newVal.tangible_assets_tool);
        this.stockTakingInstruction.strange_belongings_tool = Object.assign({}, newVal.strange_belongings_tool);
        this.stockTakingInstruction.is_ticket_required =  newVal.is_ticket_required;
      }
    },
    async mounted() {
      this.stockTakingTools = await axios.get('api/stock-taking-tools/all');
    }
  }
</script>
